import ILoan from '@root/types/Loan'
import { IGetHolidayData } from '@root/types/Holiday'
import { https } from '@root/utils'

interface IFetchLatestLoan {
  data: ILoan[]
}

interface IGetHolidayResponse {
  code: string
  data: IGetHolidayData
  message: string
}

const getLatestLoan = async (): Promise<IFetchLatestLoan> => {
  const response = await (await https()).get('/loans/active')
  return response.data
}

/**
 * @usage: For the CB Plus Flow
 * @description: Get all the holiday dates
 * @param {startDate}: The start date
 * @param {endDate}: The end date
 * @returns {IGetHolidayData}: Returns a list of holiday dates
 */
const getHoliday = async (
  startDate: string,
  endDate: string
): Promise<IGetHolidayResponse> => {
  const response = await (
    await https()
  ).get(`/loans/holiday?startDate=${startDate}&endDate=${endDate}`)
  return response.data
}

const loanApi = {
  getLatestLoan,
  getHoliday,
}

export default loanApi
